import React from 'react';
import { Navigate, Outlet, useRoutes } from 'react-router-dom';

import GuestGuard from 'utils/route/GuestGuard';
import AuthGuard from 'utils/route/AuthGuard';
import { MainProvider } from 'contexts/MainContext';

import Login from 'pages/auth/login';
// import Signup from 'pages/auth/signup';
// import ForgotPassword from 'pages/auth/forgot';
// import ResetPassword from 'pages/auth/reset';
import Landing from 'pages/landing';

import Dashboard from 'pages/main/dashboard';
import RequestTool from 'pages/request-tool';

const LandingRoutes = {
  path: '/',
  element: (
    <GuestGuard>
      <Outlet />
    </GuestGuard>
  ),
  children: [
    {
      path: '/',
      element: <Landing />
    }
  ]
};

const AuthRoutes = {
  path: 'auth',
  element: (
    <GuestGuard>
      <Outlet />
    </GuestGuard>
  ),
  children: [
    {
      path: 'login',
      element: <Login />
    }
    // {
    //   path: 'signup',
    //   element: <Signup />
    // },
    // {
    //   path: 'forgot',
    //   element: <ForgotPassword />
    // },
    // {
    //   path: 'reset',
    //   element: <ResetPassword />
    // }
  ]
};

const MainRoutes = {
  path: 'main',
  element: (
    <AuthGuard>
      <MainProvider>
        <Outlet />
      </MainProvider>
    </AuthGuard>
  ),
  children: [
    {
      path: 'dashboard',
      element: <Dashboard />
    }
  ]
};

// Public route — no guard, so it renders whether or not the visitor is signed in
// (the "Request Tool" button opens https://www.kloow.com/request-tool in a new tab).
const RequestToolRoute = {
  path: 'request-tool',
  element: <RequestTool />
};

const CatchAllRoute = {
  path: '*',
  element: <Navigate to="/" replace />
};

const ProjectRoutes = () => {
  return useRoutes([LandingRoutes, AuthRoutes, MainRoutes, RequestToolRoute, CatchAllRoute]);
};
export default ProjectRoutes;
